<template>
  <!-- 概览详情 -->
  <div class="page-dynamic-detail" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
    <div class="page-dynamic-detail-warp g-container g-wrap" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
      <div class="g-article-wrap mt-4 mt-md-10 px-4 px-md-0">
        <div class="header">
          <h1>{{detailData.title}}</h1>
          <p class="time mt-2 mt-md-5">{{detailData.publistTime | DateFormat('yyyy-MM-dd')}}</p>
          <div class="line mt-5" v-if="!$vuetify.breakpoint.mobile">
            <img src="@images/line.png" alt="">
          </div>
        </div>

        <div class="g-detail-html trans my-5" v-html="detailData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        defaultHeadImg: this.$store.state.app.defaultHeadImg,
        detailId: this.$route.query.id,
        detailData: {}
      }
    },
    methods: {
      getDetailData() {
        // this.$store.dispatch('app/changeBread', [
        //   {
        //     text: "首页",
        //     href: "/#/home"
        //   }, {
        //     text: "研究",
        //     href: "/#/overview"
        //   }, {
        //     text: "管理与建设",
        //     href: "/#/overview"
        //   }, {
        //     text: "党群活动",
        //     disabled: true
        //   }
        // ])
        this.$http
          .get('/common/articleDetail', {
            id: this.detailId,
            category: this.$route.query.category
          })
          .then(res => {
            if (res.success) {
              this.detailData = res.data

              // 动态修改面包屑
              this.$store.dispatch('app/changeBread', [
                {
                  text: "首页",
                  href: "/#/home"
                }, {
                  text: "概览",
                  href: "/#/overview"
                }, {
                  text: "管理与建设",
                  href: "/#/overview?type=2"
                }, {
                  text: "党群活动",
                  disabled: true
                }
              ])
            } else {
              this.$notify(res.message)
            }
          })
      }
    },
    created() {
      this.getDetailData()
    }
  }
</script>

<style lang="scss" scoped>
.page-dynamic-detail-warp {
  
}
</style>